// components/donation/OrganizationDonationModal.jsx
import { useState } from 'react';

export default function OrganizationDonationModal({ campaign, onClose, onDonate }) {
  const [unitsToFund, setUnitsToFund] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const unitPrice = campaign.total_price / campaign.quantity;
  const totalAmount = unitPrice * unitsToFund;
  const maxUnits = campaign.units_remaining;

  const handleDonate = async () => {
    setIsSubmitting(true);
    try {
      await onDonate(campaign.id, totalAmount, unitsToFund);
      onClose();
    } catch (error) {
      console.error('Donation failed:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm">
      <div className="bg-white dark:bg-slate-800 rounded-lg shadow-xl p-8 w-full max-w-md">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
          Fund {campaign.product_name}
        </h2>

        <div className="mb-6">
          <p className="text-gray-600 dark:text-gray-300 mb-2">
            Organization: {campaign.organization_name}
          </p>
          <p className="text-gray-600 dark:text-gray-300 mb-4">
            {campaign.units_remaining} units remaining of {campaign.quantity}
          </p>
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            How many units would you like to fund?
          </label>
          <input
            type="range"
            min="1"
            max={maxUnits}
            value={unitsToFund}
            onChange={(e) => setUnitsToFund(parseInt(e.target.value))}
            className="w-full"
          />
          <div className="flex justify-between text-sm text-gray-600 dark:text-gray-400 mt-2">
            <span>1 unit</span>
            <span>{unitsToFund} units</span>
            <span>{maxUnits} units</span>
          </div>
        </div>

        <div className="bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg mb-6">
          <div className="text-center">
            <p className="text-2xl font-bold text-blue-800 dark:text-blue-200">
              ₦{totalAmount.toLocaleString()}
            </p>
            <p className="text-sm text-blue-600 dark:text-blue-300">
              for {unitsToFund} unit{unitsToFund !== 1 ? 's' : ''} @ ₦{unitPrice.toLocaleString()} each
            </p>
          </div>
        </div>

        <div className="flex justify-end space-x-4">
          <button
            onClick={onClose}
            disabled={isSubmitting}
            className="px-4 py-2 text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={handleDonate}
            disabled={isSubmitting}
            className="px-6 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 disabled:opacity-50"
          >
            {isSubmitting ? 'Processing...' : `Fund ${unitsToFund} Unit${unitsToFund !== 1 ? 's' : ''}`}
          </button>
        </div>
      </div>
    </div>
  );
}